import useSWR from 'swr'
import { Views, ViewType } from 'types/View'
import useCleanSlugUrl from './useCleanSlugUrl'

interface ReturnType {
  data?: Views
  isLoading: boolean
  error?: Error
}

const API_URL = `/api/views`

const getViews = async (slug: string, type: string): Promise<Views> => {
  const res = await fetch(API_URL + `/?slug=${slug}&type=${type}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!res.ok) {
    throw new Error('An error occurred while posting the data.')
  }

  return res.json()
}

const useViewCounter = ({ slug, type = 'blog' }: { slug: string; type?: ViewType }): ReturnType => {
  const cleanedSlug = useCleanSlugUrl(slug)

  const { data, error } = useSWR<Views, Error>(
    API_URL + `/?slug=${cleanedSlug}&type=${type}`,
    () => getViews(cleanedSlug, type),
    {
      dedupingInterval: 60000,
    }
  )

  return {
    data,
    isLoading: !data,
    error,
  }
}

export default useViewCounter
